import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { QuoteForm } from "./QuoteForm";

export function openQuoteModal(event) {
  event?.preventDefault();
  window.dispatchEvent(new Event("open-quote-modal"));
}

export function QuoteModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("open-quote-modal", show);
    return () => window.removeEventListener("open-quote-modal", show);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => event.key === "Escape" && setOpen(false);
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  if (!open) return null;
  return (
    <div className="quote-modal" role="dialog" aria-modal="true" aria-labelledby="modal-quote-form-title" data-testid="quote-modal-overlay" onMouseDown={(event) => event.target === event.currentTarget && setOpen(false)}>
      <div className="quote-modal__panel" data-testid="quote-modal-panel">
        <button className="modal-close" type="button" onClick={() => setOpen(false)} aria-label="Fechar formulário" data-testid="quote-modal-close-button"><X /></button>
        <QuoteForm id="modal-quote" />
      </div>
    </div>
  );
}